import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  travelPlanPaper: {
    display: 'flex',
    padding: '24px',
    marginBottom: '16px',
    '& svg': {
      alignSelf: 'center',
    },
    [Theme.breakpoints.down('sm')]: {
      padding: '16px',
      flexDirection: 'column',
      '& svg': {
        display: 'none',
      },
    },
    '&:last-child': {
      marginBottom: '0',
    },
  },
  infoWrapper: {
    marginLeft: '24px',
    display: 'flex',
    flexDirection: 'column',
    '& h6': {
      color: Theme.palette.text.brand,
      fontFamily: Theme.typography.base.semiBold,
    },
    '& p': {
      color: Theme.palette.gray[750],
      fontFamily: Theme.typography.base.regular,
    },
    '& a': {
      marginLeft: '4px',
      color: Theme.palette.primary.light,
    },
    '& p, & h6': {
      fontSize: Theme.typography.size[3],
      lineHeight: '32px',
      [Theme.breakpoints.down('sm')]: {
        fontSize: Theme.typography.size[1.5],
        lineHeight: '24px',
      },
    },
    [Theme.breakpoints.down('sm')]: {
      marginLeft: '0',
    },
  },
  travelCTA: {
    marginLeft: 'auto',
    alignSelf: 'center',
    [Theme.breakpoints.down('sm')]: {
      margin: '16px 0 0',
      alignSelf: 'auto',
    },
  },
}));

export default useStyles;
